import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, of } from 'rxjs';

import { NumeronCollectionModel } from '../models/numeron.model';
import { NumeronsService } from '../services/numerons.service';

export const numeronCollectionResolver: ResolveFn<NumeronCollectionModel | null> = (route) => {
  const numeronsService = inject(NumeronsService);
  const collectionId = route.paramMap.get('collectionId');

  if (!collectionId) {
    return of(null);
  }

  return numeronsService.getNumeronCollection(collectionId).pipe(catchError(() => of(null)));
};
